import { render, staticRenderFns } from "./ClientOutOfDateWarning.vue?vue&type=template&id=79dd633c&"
import script from "./ClientOutOfDateWarning.vue?vue&type=script&lang=js&"
export * from "./ClientOutOfDateWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports